export const MOBILE_VIEW_WIDTH = 768